import React, { useState } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button, Checkbox } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, Notes } from "./styles";


const RelatorioInadimplentesBoleto = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState("");
  const [reportLink, setReportLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateReport = async () => {
    if(!dataInicio) {
      return swal("Período da pesquisa obrigatório", "Atualize o período do relatório e tente novamente", "warning");
    }

    setLoading(true);

    try {
      const response = await producaov2.post('/admin/reports/inadimplentes-boleto', {
        dueDate: new Date(dataInicio),
      });
  
      setReportLink(response.data.url);
    } catch(error) {
      swal('Houve um erro ao gerar o relatorio', 'Contate TI para verificar o problema', 'error');
    } finally {
      setLoading(false);
    }
  }

  const handleDownloadReport = () => {
    setReportLink(null);
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório de Inadimplentes Boleto</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                Date de Vencimento
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
              </FormField>
              <Notes>* Lembrando que a data de pagamento do boleto pode cair em até 3 dias</Notes>
            </FormBlock>

            <FormGroup>
              {reportLink ? (
                <Button
                  as="a"
                  href={reportLink}
                  onClick={handleDownloadReport}
                  style={{ minWidth: "80px" }}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              ) : (
                <Button
                  color="orange"
                  onClick={generateReport}
                  loading={loading}
                >
                  Gerar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioInadimplentesBoleto;
